import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    key: 'green_line',
    paths: ['terminals', 'auth', 'locations', 'tickets'],
  })(store)
}
